import React, { useState, useEffect } from 'react';
import {
    Card, CardHeader, CardBody, Heading, Flex, Badge, Box,
    Text, VStack, HStack, Icon, Spinner, Button
} from '@chakra-ui/react';
import { FiCheckCircle, FiAlertCircle, FiChevronRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const DashboardCommBookWidget = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        fetchStatus();
    }, []);

    const fetchStatus = async () => {
        try {
            const res = await authAPI.communicationBook.getStatus();
            setStatuses(res.data);
        } catch (error) {
            console.error("Failed to fetch comm book status", error);
        } finally {
            setLoading(false);
        }
    };

    const handleNavigate = () => {
        navigate('/teacher/comm-book');
    };

    if (loading) {
        return (
            <Card h="100%" variant="outline" borderColor="gray.200" shadow="sm">
                <CardBody display="flex" justifyContent="center" alignItems="center">
                    <Spinner size="sm" color="gray.500" />
                </CardBody>
            </Card>
        );
    }

    // Sort: Pending first
    const sortedStatuses = [...statuses].sort((a, b) => {
        if (a.is_sent === b.is_sent) return 0;
        return a.is_sent ? 1 : -1;
    });

    const pendingCount = statuses.filter(s => !s.is_sent).length;

    return (
        <Card h="100%" overflow="hidden" variant="outline" borderColor="gray.200" shadow="sm">
            <CardHeader pb={2}>
                <Flex justify="space-between" align="center">
                    <HStack>
                        <Heading size="md" color="gray.700">聯絡簿狀態</Heading>
                        {pendingCount > 0 && (
                            <Badge colorScheme="red" variant="solid" borderRadius="full">
                                {pendingCount} 未發
                            </Badge>
                        )}
                    </HStack>
                    <Button size="xs" variant="ghost" rightIcon={<FiChevronRight />} onClick={handleNavigate}>
                        前往
                    </Button>
                </Flex>
            </CardHeader>
            <CardBody p={0} overflowY="auto">
                <VStack spacing={0} align="stretch">
                    {sortedStatuses.length === 0 ? (
                        <Box p={4} textAlign="center">
                            <Text fontSize="sm" color="gray.400">無負責班級</Text>
                        </Box>
                    ) : sortedStatuses.map((s) => (
                        <Flex
                            key={s.class_id}
                            p={3}
                            borderBottom="1px solid"
                            borderColor="gray.100"
                            justify="space-between"
                            align="center"
                            _hover={{ bg: "gray.50" }}
                            cursor="pointer"
                            onClick={handleNavigate}
                        >
                            <Text fontWeight="medium" fontSize="sm">{s.class_name}</Text>
                            <HStack>
                                {s.is_sent ? (
                                    <Badge colorScheme="green" variant="subtle">已發送</Badge>
                                ) : (
                                    <Badge colorScheme="red" variant="subtle">未發送</Badge>
                                )}
                            </HStack>
                        </Flex>
                    ))}
                </VStack>
            </CardBody>
        </Card>
    );
};

export default DashboardCommBookWidget;
